import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBoxes = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 10.25v-4.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1M4.75 18.25v-2.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1M13.75 6.25v-.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1M13.75 18.25v-6.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1"
    />
  </svg>
);
export default SvgBoxes;
